import { resolveContent } from './resolvers/checkout.resolver';

export default ['$stateProvider', $stateProvider => {
    $stateProvider
        .state('checkout', {
            url: '/checkout',
            component: 'checkout',
            abstract: true
        })
        .state('checkout.credit', {
            url: '/credit',
            component: 'customise',
            resolve: {
                content: resolveContent('checkoutdays')
            }
        })
        .state('checkout.customise', {
            url: '/customise',
            component: 'options',
            resolve: {
                content: resolveContent('options')
            }
        })
        .state('checkout.suggestions', {
            url: '/suggestions',
            component: 'suggestions',
            resolve: {
                content: resolveContent('suggestions')
            }
        })
        .state('checkout.payment', {
            url: '/payment',
            component: 'payment',
            resolve: {
                content: resolveContent('payment')
            }
        })
        .state('checkout.review', {
            url: '/review',
            component: 'review',
            resolve: {
                content: resolveContent('review')
            }
        })
        .state('checkout.confirmation', {
            url: '/confirmation',
            component: 'confirmation'
        })
        ;
}];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/checkout/checkout.routes.js